import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const BankPaymentList = () => {
    // State for bank payments and filtered bank payments
    const [bankPayments, setBankPayments] = useState([]);
    const [filteredBankPayments, setFilteredBankPayments] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch bank payment entries when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}bankpayment`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setBankPayments(data.data);
                    setFilteredBankPayments(data.data); // Set initial filtered bank payments
                }
            })
            .catch(error => console.error('Error fetching bank payment entries:', error));
    }, []);

    // Handle search term change
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        // Filter bank payments based on the search term
        const filtered = bankPayments.filter(payment =>
            payment.staff_id.toString().includes(term) ||
            payment.c_id.toString().includes(term) ||
            payment.amount.toString().includes(term) ||
            payment.description.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredBankPayments(filtered);
    };

    // Navigate to the edit bank payment page
    const handleEdit = (id) => {
        navigate(`/EditBankPayment/${id}`);
    };

    // Navigate to the add bank payment page
    const handleAdd = () => {
        navigate('/AddBankPayment');
    };

    // Handle bank payment deletion
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this bank payment entry?")) {
            fetch(`${BASE_URL}bankpayment/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        // Remove the deleted bank payment from both lists (bankPayments and filteredBankPayments)
                        setBankPayments(bankPayments.filter(payment => payment.id !== id));
                        setFilteredBankPayments(filteredBankPayments.filter(payment => payment.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting bank payment entry:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Bank Payment Entries List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                    {/* Additional breadcrumb items if necessary */}
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Basic Tables start */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Bank Payment</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search by Staff ID, Customer ID, Amount, or Description</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search by Staff ID, Customer ID, Amount, or Description"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>Staff ID</th>
                                                <th>Customer ID</th>
                                                <th>Amount</th>
                                                <th>Description</th>
                                                <th>Created At</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredBankPayments.map(payment => (
                                                <tr key={payment.id}>
                                                    <td>{payment.staff_id || 'N/A'}</td>
                                                    <td>{payment.c_id || 'N/A'}</td>
                                                    <td>{payment.amount || 'N/A'}</td>
                                                    <td>{payment.description || 'N/A'}</td>
                                                    <td>{new Date(payment.created_at).toLocaleString()}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(payment.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(payment.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Basic Tables end */}
        </div>
    );
};

export default BankPaymentList;
